import NotifyComp from "component/NotifyComp"
import React from "react"

export const Notification = () => {
    return (
        <NotifyComp />
    )
}
